import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-api-integration-upload',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './api-integration-upload.component.html',
  styleUrl: './api-integration-upload.component.scss',
})
export class ApiIntegrationUploadComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() readonly = false;
  @Input() showValidation = true;

  @Input() httpMethodOptions: string[] = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];
  @Input() authenticationTypeOptions: string[] = ['Bearer Token', 'API Key', 'Basic Auth', 'OAuth 2.0', 'Custom'];
  @Input() responseFormatOptions: string[] = ['JSON', 'XML', 'CSV', 'Text'];

  // Dropdown states (kept inside component so it's reusable)
  isHttpMethodDropdownOpen = false;
  isAuthenticationTypeDropdownOpen = false;
  isResponseFormatDropdownOpen = false;

  toggleHttpMethodDropdown(): void {
    if (this.readonly) return;
    this.isHttpMethodDropdownOpen = !this.isHttpMethodDropdownOpen;
    this.isAuthenticationTypeDropdownOpen = false;
    this.isResponseFormatDropdownOpen = false;
  }

  selectHttpMethod(method: string): void {
    if (this.readonly) return;
    this.form.patchValue({ httpMethod: method });
    this.isHttpMethodDropdownOpen = false;
    this.form.get('httpMethod')?.markAsTouched();
  }

  getSelectedHttpMethod(): string {
    return this.form.get('httpMethod')?.value || 'Select HTTP Method';
  }

  isHttpMethodSelected(method: string): boolean {
    return this.form.get('httpMethod')?.value === method;
  }

  toggleAuthenticationTypeDropdown(): void {
    if (this.readonly) return;
    this.isAuthenticationTypeDropdownOpen = !this.isAuthenticationTypeDropdownOpen;
    this.isHttpMethodDropdownOpen = false;
    this.isResponseFormatDropdownOpen = false;
  }

  selectAuthenticationType(type: string): void {
    if (this.readonly) return;
    this.form.patchValue({ authenticationType: type });
    this.isAuthenticationTypeDropdownOpen = false;
    this.form.get('authenticationType')?.markAsTouched();
  }

  getSelectedAuthenticationType(): string {
    return this.form.get('authenticationType')?.value || 'Select Authentication Type';
  }

  isAuthenticationTypeSelected(type: string): boolean {
    return this.form.get('authenticationType')?.value === type;
  }

  toggleResponseFormatDropdown(): void {
    if (this.readonly) return;
    this.isResponseFormatDropdownOpen = !this.isResponseFormatDropdownOpen;
    this.isHttpMethodDropdownOpen = false;
    this.isAuthenticationTypeDropdownOpen = false;
  }

  selectResponseFormat(format: string): void {
    if (this.readonly) return;
    this.form.patchValue({ responseFormat: format });
    this.isResponseFormatDropdownOpen = false;
    this.form.get('responseFormat')?.markAsTouched();
  }

  getSelectedResponseFormat(): string {
    return this.form.get('responseFormat')?.value || 'Select Response Format';
  }

  isResponseFormatSelected(format: string): boolean {
    return this.form.get('responseFormat')?.value === format;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (target?.closest?.('.custom-dropdown-wrapper')) return;
    this.isHttpMethodDropdownOpen = false;
    this.isAuthenticationTypeDropdownOpen = false;
    this.isResponseFormatDropdownOpen = false;
  }
}

